/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-poll.stache';
import can from 'can';
import _ from 'lodash';
import localStorageService from 'scripts/services/localstorage-service';
import domUtil from 'scripts/utils/dom';
import resultTemplate from './result.stache';
import answerTemplate from './answer.stache';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'live-poll',
    template: template,
    leakScope: false,
    events: {
        inserted() {
            this.pollId = this.viewModel.pollId;
            this.resultsInterval = null;
            this.resultsElements = null;
            this.votedAnswer = null;
            this.pollPath = 'https://static.polldaddy.com/p/{pollId}.js';
            this.dataContainer = this.element.find(
                '.s-video-landing-slider-item__container',
            );

            let pollUrl = can.sub(this.pollPath, { pollId: this.pollId });
            let scriptSrc = `${pollUrl}?t=${+new Date()}`;
            let isVoted = this.userAlreadyVoted(this.pollId);

            this.fillRequiredAttrs(this.pollId);

            domUtil.addScript(scriptSrc, () => {
                let isClosed = this.pollIsClosed();
                this.setTitle();
                if (isVoted && !isClosed) {
                    let viewResults = this.element.find(
                        '.PDS_Poll .pds-vote a.pds-view-results',
                    );
                    this.generateMouseClickEvent(viewResults[0]);
                    this.fetchResults();
                } else if (isClosed) {
                    this.fetchResults();
                } else {
                    this.listenLocalStorageWriteEvent();
                    this.showAnswers();
                }
            });
        },

        localStorageChangeHandler(data) {
            let pollUrl = can.sub(this.pollPath, { pollId: this.pollId });
            let scriptSrc = `${pollUrl}?t=${+new Date()}`;
            let resultLocalStorageKey = can.sub(
                'PD_poll_result_{pollId}',
                this.pollId,
            );
            let votedItem = localStorageService.getItem(resultLocalStorageKey);

            if (votedItem) {
                this.votedAnswer = votedItem;
                this.element.find('.PDS_Poll').html('');
                this.element
                    .find('.s-video-landing-slider-item__container')
                    .html('');
            } else {
                return;
            }
            setTimeout(() => {
                // This timeout is required for polldaddy.
                domUtil.addScript(scriptSrc, () => {
                    let viewResults = this.element.find(
                        '.PDS_Poll .pds-vote a.pds-view-results',
                    );
                    this.generateMouseClickEvent(viewResults[0]);
                    this.fetchResults();
                });
            }, 3 * 1000);
        },

        listenLocalStorageWriteEvent() {
            window.addEventListener(
                'storage',
                this.localStorageChangeHandler.bind(this),
                false,
            );
        },

        fillRequiredAttrs(pollId) {
            this.element.find('.PDS_Poll').attr('id', `PDI_container${pollId}`);
        },

        fetchResults() {
            let resultsInterval = setInterval(() => {
                this.resultsElements = this.element.find(
                    '.PDS_Poll .pds-feedback-group',
                );
                if (
                    this.resultsElements &&
                    this.resultsElements.length &&
                    !this.resultsCollection
                ) {
                    clearInterval(resultsInterval);
                    this.showResults();
                }
            }, 500);
        },

        pollIsClosed() {
            let voteButton = this.element.find('.PDS_Poll .pds-vote-button'),
                viewResults = this.element.find('.PDS_Poll .pds-view-results');

            if (
                voteButton &&
                voteButton.length &&
                viewResults &&
                viewResults.length
            ) {
                return false;
            } else {
                return true;
            }
        },

        setTitle() {
            let title = this.element
                .find('.pds-question .pds-question-top')
                .text();
            this.element.find('.s-video-landing-slider-item__text').text(title);
        },

        showResults() {
            this.resultsCollection = [];
            this.resultsElements.each((key, value) => {
                let label = $(value).find('label.pds-feedback-label');

                let title = label
                        .find('.pds-answer-text')
                        .text()
                        .trim(),
                    resultInPercent = label
                        .find('.pds-feedback-result .pds-feedback-per')
                        .text()
                        .trim();

                this.resultsCollection.push({
                    title: title,
                    resultInPercent: resultInPercent,
                });
            });

            this.renderResults();
        },

        renderResults() {
            this.dataContainer.html('');
            _.forEach(this.resultsCollection, (result) => {
                let isSelected =
                    this.votedAnswer && this.votedAnswer.title == result.title;

                this.dataContainer.append(
                    resultTemplate({
                        title: result.title,
                        resultInPercent: result.resultInPercent,
                        isSelected,
                    }),
                );
            });
        },

        showAnswers() {
            this.answersCollection = [];
            let answersInterval = setInterval(() => {
                this.answersElements = this.element.find(
                    `#pds-answer${this.pollId} span.pds-answer-group`,
                );
                if (this.answersElements && this.answersElements.length) {
                    clearInterval(answersInterval);
                    this.answersElements.each((key, value) => {
                        let label = $(value).find('label');

                        let id = label.attr('for').replace('PDI_answer', ''),
                            title = label.find('.pds-answer-span').text();
                        if (title && id) {
                            this.answersCollection.push({
                                title: title,
                                id: id,
                            });
                        }
                    });
                    this.renderAnswers();
                }
            }, 500);
        },

        generateMouseClickEvent(element) {
            let evObj = document.createEvent('MouseEvents');
            evObj.initMouseEvent(
                'click',
                true,
                true,
                null,
                null,
                0,
                0,
                90,
                90,
                false,
                false,
                false,
                false,
                0,
                null,
            );
            element.dispatchEvent(evObj);
        },

        renderAnswers() {
            this.dataContainer.html('');
            _.forEach(this.answersCollection, (answer) => {
                this.dataContainer.append(
                    answerTemplate({ title: answer.title, id: answer.id }),
                );
            });
        },

        userAlreadyVoted(pollId) {
            let pollKey = can.sub('PD_poll_result_{pollId}', pollId);
            let votedPoll = localStorageService.getItem(pollKey);

            if (votedPoll) {
                this.votedAnswer = votedPoll;
                return true;
            }
            return;
        },

        voteForAnswer(id, title) {
            let targetAnswerElement = this.element
                .find('.PDS_Poll')
                .find(can.sub('label[for="PDI_answer{id}"]', id));

            if (targetAnswerElement && targetAnswerElement.length) {
                this.votedAnswer = { id: id, title: title };
                localStorageService.setItem(
                    can.sub('PD_poll_result_{pollId}', this.pollId),
                    this.votedAnswer,
                );
                this.generateMouseClickEvent(targetAnswerElement[0]);
                setTimeout(() => {
                    let pollVoteButton = this.element.find(
                        '.PDS_Poll .pds-vote a.pds-vote-button',
                    );
                    this.generateMouseClickEvent(pollVoteButton[0]);
                    this.fetchResults();
                    dtm.trackPollSubmission();
                }, 100);
            }
        },

        '.s-video-landing-slider-item__vote-link click': function(
            element,
            event,
        ) {
            let answerItem = $(event.currentTarget);
            if (answerItem.hasClass('disabled')) {
                return;
            }

            let answerId = answerItem.data('answer-id'),
                answerTitle = $(event.target)
                    .text()
                    .trim();

            if (answerId) {
                $(event.currentTarget).addClass(
                    's-video-landing-slider-item__vote-result-player--selected',
                );
                this.element
                    .find('.s-video-landing-slider-item__vote-link')
                    .addClass('disabled');
                this.voteForAnswer(answerId, answerTitle);
            }
        },

        destroy() {
            window.removeEventListener(
                'storage',
                this.localStorageChangeHandler.bind(this),
            );
        },
    },
    viewModel: {
        define: {
            pollId: {
                type: 'string',
                value: '',
            },
        },
    },
});
